export default "dist/images/block-pricing-box-basic.93ea6bb.png";